import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, Subject} from 'rxjs';

import { SessionService } from '@core';

import { PatientAddressUpdateResult, PatientAddressUpdate } from 'planner-shared';

import { StopOptimizationHttpParams } from '../../interceptors/stop-optimization-http-params';
import {EmployeeAdminTaskAddressUpdate} from "../../models/employee-admin-task-address-update.model";

@Injectable({ providedIn: 'root' })
export class AddressUpdateService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);

    public updateTasksSubject$: Subject<void>;
    constructor() {
        this.updateTasksSubject$ = new Subject<void>();
    }


    public updateAddressForPatient(patientAddressUpdate: PatientAddressUpdate): Observable<PatientAddressUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/update_patient_addresses/`;
        const body = {
            requestId: this.sessionService.requestId,
            addressUpdates: [JSON.parse(JSON.stringify(patientAddressUpdate))]
        };
        return this.httpClient.put<PatientAddressUpdateResult>(url, body, {
            params: new StopOptimizationHttpParams(true).getHttpParams()
        });
    }

    public updateAddressForAdministrativeTask(adminTaskAddressUpdate: EmployeeAdminTaskAddressUpdate): Observable<PatientAddressUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/admin_tasks_addresses/${this.sessionService.requestId}`;
        const body = {
            addresses: [adminTaskAddressUpdate]
        };
        return this.httpClient.put<PatientAddressUpdateResult>(url, body, {
            params: new StopOptimizationHttpParams(true).getHttpParams()
        });
    }

}
